
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@src/store';
import { backupsActions } from '@src/store/reducers/backupsReducer';
import { projectsActions } from "../../../store/reducers/projectsReducer";
import { userActions } from "../../../store/reducers/userReducer";

import { DialogManagerService } from '@src/services';

@Component({
    selector: 'backups',
    template: require('./backups.component.html'),
    styles: [require('./backups.component.scss')]
})
export class BackupsComponent implements OnDestroy, OnInit {

    public unsubscribe: any;
    public backups: any
    public pageId: number = 1
    public _filter: any
    public envs:any;



    constructor(private store: Store, @Inject('$stateParams') private $stateParams: any, private dialogManagerService: DialogManagerService) {
        this.store = store;
        this.unsubscribe = this.store.subscribe(() => { });
        store.dispatch({ type: projectsActions.GET_PROJECTS });
        store.dispatch({ type: userActions.GET_CURRENT_USER_DETAILS }).then((res) => {
            store.dispatch({ type: userActions.GET_USER, payload: { userId: res.data.id } });
        });
    }

    ngOnInit(): void {
        var payload = {
            "pipelineId": parseInt(this.$stateParams.id),
            "environmentId": null,
            "environmentTypeId": null,
            "pageNumber": this.pageId,
            "pageCount": 15,
            "startTime": null,
            "endTime": null,
        };

        this.store.dispatch({ type: backupsActions.GET_BACKUPS, payload: { data: payload } })
            .then(resp => {

                // setTimeout(() => {

                //     resp.forEach(respEnv => {
                //         this.$stateParams.envs.forEach(env => {
                //             if (respEnv.envId == env.id)
                //                 respEnv.envId = env.name;
                //         });

                //     });
                //     this.backups = resp;
                // });
                this.backups=resp;
                if(this.envs){
                    this.changeEnvIdToEnvName();
                }

            });
        this.pageId += 1;
    }

    ngOnDestroy(): void {
        this.unsubscribe();
    }

    changeEnvIdToEnvName(){
        this.backups.forEach(respEnv => {
            this.envs.forEach(env => {
                if (respEnv.envId == env.id)
                    respEnv.envId = env.name;
            });
        });
        this.backups = [...this.backups]; 

    }
    setEnvs(envs){
        this.envs=envs;
        if(this.backups){
            this.changeEnvIdToEnvName();
        }
    }

    filter(data) {
        this._filter = data;
        this.getRecords()
    }

    deleteItem(item) {
        if (!item.data.id)  return
            const onConfirm = () => {
                const payload = {
                    backupId: item.data.id
                };
                this.store.dispatch({ type: backupsActions.DELETE_BACKUP, payload: payload })
                    .then(resp => {
                        if (resp) {
                            const filterdArr = this.backups.filter(x => x.id !== item.data.id);
                            this.backups = filterdArr
                        }
                    }
                    );;
            }
            const dialogData = { title: 'Delete Backup', action: 'delete', item: item.data.name };
            this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
    }


    public getRecords() {
        let pageNumber = 1
        const payload = {
            "pipelineId": parseInt(this._filter.data.pipelineId),
            "environmentId": !this._filter.data.environments || (this._filter.data.environments && this._filter.data.environments.length === 0) || (this._filter.data.environments.length === 1 && this._filter.data.environments[0] == null) ? null : this._filter.data.environments,
            "environmentTypeId": this._filter.data.environmentTypeId.length === 0 || (this._filter.data.environmentTypeId.length === 1 && this._filter.data.environmentTypeId[0] == null) ? null : this._filter.data.environmentTypeId,
            "pageCount": 15,
            "pageNumber": pageNumber,
            "startTime": this._filter.data.startTime,
            "endTime": this._filter.data.endTime,
            "isValidated": this._filter.data.isValidated === 'All' ? null : (this._filter.data.isValidated === 'Valid' ? true : false)
        };


        this.store.dispatch({ type: backupsActions.GET_BACKUPS, payload: { data: payload } })
            .then(resp => {
                //add names for envs instead of getting them from server
                this.backups = resp
                resp.forEach(element => {
                    if (this._filter.data.envs) {
                        this._filter.data.envs.forEach(env => {
                            if (element.envId === env.id)
                                element.envId = env.name;
                        })
                    }
                })
            })
        pageNumber += 1
    }

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/buckups-ang7/backups.component.ts